import { render, staticRenderFns } from "./UploadPdfForm.vue?vue&type=template&id=a9448864&"
import script from "./UploadPdfForm.vue?vue&type=script&lang=js&"
export * from "./UploadPdfForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports